export default __webpack_public_path__ + "static/media/partner-9.0accfb6a.png";